import React from 'react';
import { cva, VariantProps } from 'class-variance-authority';

const variantBaseStyles = {
  H1: 'font-semibold text-[24px]',
  H2: 'font-semibold text-[20px]',
  H3: 'font-semibold text-[16px]',
  Title2: 'font-semibold text-[36px]',
  Title3: 'font-semibold text-[28px]',
  Title5: 'font-semibold text-[13px]',
  Caption1: 'text-[13px]',
  Caption2: 'text-[12px]',
  Caption3: 'font-semibold text-[10px]',
  Body: 'text-[16px]',
};

const smBaseStyles = {
  H1: 'sm:font-semibold sm:text-[24px]',
  H2: 'sm:font-semibold sm:text-[20px]',
  H3: 'sm:font-semibold sm:text-[16px]',
  Title2: 'sm:font-semibold sm:text-[36px]',
  Title3: 'sm:font-semibold sm:text-[28px]',
  Title5: 'sm:font-semibold sm:text-[13px]',
  Caption1: 'sm:text-[13px]',
  Caption2: 'sm:text-[12px]',
  Caption3: 'sm:font-semibold sm:text-[10px]',
  Body: 'sm:text-[16px]',
};

const mdBaseStyles = {
  H1: 'md:font-semibold md:text-[24px]',
  H2: 'md:font-semibold md:text-[20px]',
  H3: 'md:font-semibold md:text-[16px]',
  Title2: 'md:font-semibold md:text-[36px]',
  Title3: 'md:font-semibold md:text-[28px]',
  Title5: 'md:font-semibold md:text-[13px]',
  Caption1: 'md:text-[13px]',
  Caption2: 'md:text-[12px]',
  Caption3: 'md:font-semibold md:text-[10px]',
  Body: 'md:text-[16px]',
};

const lgBaseStyles = {
  H1: 'lg:font-semibold lg:text-[24px]',
  H2: 'lg:font-semibold lg:text-[20px]',
  H3: 'lg:font-semibold lg:text-[16px]',
  Title2: 'lg:font-semibold lg:text-[36px]',
  Title3: 'lg:font-semibold lg:text-[28px]',
  Title5: 'lg:font-semibold lg:text-[13px]',
  Caption1: 'lg:text-[13px]',
  Caption2: 'lg:text-[12px]',
  Caption3: 'lg:font-semibold lg:text-[10px]',
  Body: 'lg:text-[16px]',
};

const textStyles = cva('m-0 p-0', {
  variants: {
    variant: variantBaseStyles,
    sm: smBaseStyles,
    md: mdBaseStyles,
    lg: lgBaseStyles,
  },
  defaultVariants: {
    variant: 'Body',
  },
});

type TextProps = React.HTMLAttributes<HTMLElement> &
  VariantProps<typeof textStyles> & {
    children: React.ReactNode;
  };

export function Text({
  variant = 'Body',
  sm,
  md,
  lg,
  children,
  className,
  ...props
}: TextProps) {
  const textProps = {
    className: textStyles({
      variant,
      sm,
      md,
      lg,
      className,
    }),
    ...props,
  };

  if (variant === 'H1') {
    return <h1 {...textProps}>{children}</h1>;
  } else if (variant === 'H2') {
    return <h2 {...textProps}>{children}</h2>;
  } else if (variant === 'H3') {
    return <h3 {...textProps}>{children}</h3>;
  } else {
    return <p {...textProps}>{children}</p>;
  }
}
